module.exports = __webpack_public_path__ + "img/photograph3.f31dcb83.png";